module.exports = __webpack_public_path__ + "static/media/PaymentFileTemplate.f70b40d9.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/views/payment-upload/PaymentFileTemplate.xlsx
// module id = 736
// module chunks = 0